"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _curry = _interopRequireDefault(require("./curry"));

var _sortBy2 = _interopRequireDefault(require("./internal/_sortBy"));

/**
 * Sort `subject` according to the value returned by `getSortValue`.
 *
 * @example
 * // returns List [ 2, 1, 3 ]
 * sortBy(
 *   (n) => n % 2,
 *   List.of(1, 2, 3)
 * );
 *
 * @example
 * // returns OrderedMap { "one" => 1, "two" => 2, "three" => 3 }
 * sortBy(
 *   (n) => n % 2,
 *   Map({three: 3, one: 1, two: 2})
 * );
 *
 * @param  {Function} getSortValue returns a value to sort on for each item in `subject`.
 * @param  {Array|Iterable|Object} subject the thing to sort.
 * @return {Iterable} an ordered version of `subject` (e.g. sorting a `Map` returns an `OrderedMap`).
 */
var _default = (0, _curry.default)(_sortBy2.default);

exports.default = _default;
module.exports = exports.default;